import { Expose, Type } from 'class-transformer';
import { Vehicle } from '../vehicle';
import { VehicleReport } from './vehicle-report';

export class PanicButtonReport extends VehicleReport {
  @Expose({ name: 'vehicle' })
  @Type(() => Vehicle)
  vehicle: Vehicle;

  @Expose({ name: 'preview_url' })
  previewUrl?: string;
}
